import "./StoryIntro.css";

const StoryIntro = () => {
  return (
    <section className="story-intro">
      <div className="container">
        <div className="story-intro-wrapper">
          {/* Left Image */}
          <div className="story-image">
            <img
              src="/assets/story/story-intro.webp"
              alt="Our Story"
              loading="lazy"
              width="600"
              height="800"
            />
          </div>

          {/* Right Content */}
          <div className="story-content">
            <span>OUR JOURNEY</span>

            <h2>
              Preserving India's
              <br />
              Finest Handloom Heritage
            </h2>

            <p>
              At <strong>Yadnya Handloom</strong>, every saree tells a
              story woven with patience, artistry, and generations of
              craftsmanship. Our journey began with a simple vision—
              to celebrate India's timeless weaving traditions while
              bringing authentic handloom masterpieces to modern women.
            </p>

            <p>
              Every weave reflects the dedication of skilled artisans
              who spend weeks, and sometimes months, creating a single
              masterpiece. Each thread carries tradition, elegance,
              and unmatched craftsmanship.
            </p>

            <div className="signature">
              <h3>Yadnya Handloom</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryIntro;